import * as React from 'react'
import { FilterProps, Filter } from 'react-admin'
import { JointPurchaseFiltersArray } from './Filters'

const JointPurchaseFilter: React.FC<Omit<FilterProps, 'children'>> = (
  props
) => {
  return (
    <Filter {...props}>
      {JointPurchaseFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default JointPurchaseFilter
